import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Btn, Modal } from "./ui";

/** Zeigt Zugangsdaten EINMAL an (das Passwort wird nirgends gespeichert) — mit Kopierfunktion. */
export function CredentialsDialog({
  creds,
  title,
  onClose,
}: {
  creds: { login: string; password: string; appUrl?: string | null } | null;
  title: string;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);
  if (!creds) return null;
  // Kunden bekommen die Kunden-Adresse (z. B. app.…), nicht die Adresse der Verwaltung
  const address = creds.appUrl || window.location.origin;
  const text = `CRM: ${address}\nBenutzer: ${creds.login}\nPasswort: ${creds.password}`;
  return (
    <Modal
      open
      onClose={onClose}
      title={title}
      lead="Das Passwort wird nur jetzt angezeigt und nirgends gespeichert. Bitte sofort an den Kunden weitergeben."
      width={500}
      footer={
        <>
          <Btn
            onClick={async () => {
              await navigator.clipboard.writeText(text).catch(() => {});
              setCopied(true);
            }}
          >
            {copied ? <Check size={15} /> : <Copy size={15} />}
            {copied ? "Kopiert" : "Alles kopieren"}
          </Btn>
          <Btn variant="primary" onClick={onClose}>
            Fertig
          </Btn>
        </>
      }
    >
      <div className="pf-cred">
        <div>
          <em>Adresse</em>
          {address}
        </div>
        <div>
          <em>Benutzer</em>
          {creds.login}
        </div>
        <div>
          <em>Passwort</em>
          <strong>{creds.password}</strong>
        </div>
      </div>
      <p className="pf-muted" style={{ fontSize: 12, marginBottom: 0 }}>
        Beim ersten Login sollte der Kunde sein Passwort unter Einstellungen ändern.
      </p>
    </Modal>
  );
}
